import React, { useState, useEffect } from 'react'
import styles from './profile.module.scss'
import Robbot from '../../../../icons/robbot.svg'
import PageComponent from '../../../Pages/PageComponent'
import cx from 'classnames'
import { useNavigate } from 'react-router-dom'
import Arrow from '../../../../icons/arrow.svg'
import {
  getForms,
  getAuthUserPdf,
  createAuthUserForm,
  getFormsInProfile,
} from '../../../../api/formApi'
import * as moment from 'moment'
import {
  setCopyReimbursementRef,
  setReimbursementRef,
} from '../../../../redux/actions/payment'
import { useDispatch, useSelector } from 'react-redux'
import {
  authorizedPerson,
  careReceipients,
  legalRepresentations,
  quizQuestions,
  representationByCommerciallyActive,
  representationByPrivateIndividual,
  representativePerson,
} from '../../../../redux/defaultStates'
import {
  setEpmptyQuizState,
  setFormCopy,
} from '../../../../redux/actions/quizQuestions'
import { setToastNotification } from '../../../../redux/actions/toastNotification'
import {
  setEmptyActive,
  setEmptyAuth,
  setEmptyCare,
  setEmptyLegal,
  setEmptyPrivate,
  setEmptyRep,
} from '../../../../redux/actions/careReceipients'

const Profile = () => {
  const [rotate, setRotate] = useState(false)
  const [formsData, setFormsData] = useState(null)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const userData = useSelector((state) => state.userDetails)
  const { email } = useSelector((state) => state.userDetails)
  const [getPdfDisabled, setGetPdfDisabled] = useState('')
  const [formDisabled, setFormDisabled] = useState(false)
  const [activeIndex, setActiveIndex] = useState([]) // Track active item
  useEffect(() => {
    dispatch(setReimbursementRef(''))
    dispatch(setEpmptyQuizState(quizQuestions))
    dispatch(setEmptyRep(representativePerson))
    dispatch(setEmptyActive(representationByCommerciallyActive))
    dispatch(setEmptyAuth(authorizedPerson))
    dispatch(setEmptyPrivate(representationByPrivateIndividual))
    dispatch(setEmptyCare(careReceipients))
    dispatch(setEmptyLegal(legalRepresentations))
  }, [])
  useEffect(() => {
    getFormsInProfile()
      .then((data) => setFormsData(data.content.sort()))
      .catch((err) => console.log(err))
  }, [])

  const handleRotateCare = (index) => {
    setActiveIndex(
      (prevIndexes) =>
        prevIndexes.includes(index)
          ? prevIndexes.filter((i) => i !== index) // Remove if exists (toggle off)
          : [...prevIndexes, index], // Add if not exists (toggle on)
    ) // setActiveIndex(activeIndex === index ? null : index) // Toggle current, close others
  }

  const handleGetPdf = (ref) => {
    const body = { ref }
    setGetPdfDisabled(ref)
    getAuthUserPdf(body)
      .then(() => {
        dispatch(
          setToastNotification({
            type: 'success',
            toastTittle: 'Formular erfolgreich gesendet!',
            toastBody: 'Bitte überprüfen Sie ihre E-Mails.',
          }),
        )
      })
      .catch((err) => console.log(err))
      .finally(() => setGetPdfDisabled(''))
  }

  const handleViewForm = (ref) => {
    dispatch(setReimbursementRef(ref))
    navigate('/summary')
  }
  const handleNewFormStart = () => {
    const requestBody = {
      email,
      params: {},
      option: 2,
    }
    setFormDisabled(true)
    createAuthUserForm(requestBody)
      .then((data) => {
        dispatch(setReimbursementRef(data.ref))
        dispatch(setEpmptyQuizState(quizQuestions))
        dispatch(setEmptyRep(representativePerson))
        dispatch(setEmptyActive(representationByCommerciallyActive))
        dispatch(setEmptyAuth(authorizedPerson))
        dispatch(setEmptyPrivate(representationByPrivateIndividual))
        dispatch(setEmptyCare(careReceipients))
        dispatch(setEmptyLegal(legalRepresentations))
        navigate('/startChallenge')
      })
      .catch((err) => console.log(err))
      .finally(() => setFormDisabled(false))
  }
  const handleCopyForm = (ref) => {
    dispatch(setCopyReimbursementRef(ref))
    dispatch(setFormCopy(true))
    const requestBody = {
      email,
      params: {},
      option: 2,
    }
    setFormDisabled(true)
    createAuthUserForm(requestBody)
      .then((data) => {
        dispatch(setReimbursementRef(data.ref))
        navigate('/startChallenge')
      })
      .catch((err) => console.log(err))
      .finally(() => setFormDisabled(false))
  }

  return (
    <PageComponent>
      <div className={styles.profile}>
        <div className={styles.formInfoWrapper}>
          <div>
            <div>
              <h1>Hallo, {userData.firstName}</h1>
              <p>Hier finden Sie alle Ihre Formulare.</p>
              <button
                onClick={handleNewFormStart}
                disabled={formDisabled}
                className={cx({
                  [styles.disabled]: formDisabled,
                })}
              >
                Ein neues Formular starten
              </button>
            </div>
            <div className={styles.robbot}>
              <img src={Robbot} alt={Robbot} />
            </div>
          </div>
          <div>
            {formsData
              ?.map((careRecipient, index) => {
                return (
                  <div className={styles.forms}>
                    <span className={styles.formWrap}>
                      <p>{careRecipient.careRecipientName}</p>
                      <img
                        src={Arrow}
                        alt={Arrow}
                        onClick={() => handleRotateCare(index)}
                        className={cx({
                          [styles.rotate]: activeIndex.includes(index),
                        })}
                      />
                    </span>
                    {activeIndex.includes(index) && (
                      <div>
                        <ul>
                          {careRecipient.forms
                            ?.map((form) => {
                              return (
                                <div className={styles.formWrapper}>
                                  <p>{form.authorizedPersonName}</p>
                                  {form.authorizedPersonItems
                                    .map((item) => {
                                      return (
                                        <li>
                                          <p>
                                            {item.periodOfAbsenceFrom} -{' '}
                                            {item.periodOfAbsenceTo}
                                          </p>
                                          <p>
                                            <button
                                              onClick={() =>
                                                handleViewForm(item.ref)
                                              }
                                            >
                                              Formular anzeigen
                                            </button>
                                            <button
                                              onClick={() =>
                                                handleCopyForm(item.ref)
                                              }
                                            >
                                              Formular kopieren
                                            </button>
                                            <button
                                              onClick={() => handleGetPdf(item.ref)}
                                              disabled={
                                                getPdfDisabled ===
                                                form.reimbursementRef
                                              }
                                              className={cx({
                                                [styles.disabled]:
                                                  getPdfDisabled ===
                                                  form.reimbursementRef,
                                              })}
                                            >
                                              PDF herunterladen
                                            </button>
                                          </p>
                                        </li>
                                      )
                                    })
                                    .sort()}
                                </div>
                              )
                            })
                            .sort()}{' '}
                        </ul>
                      </div>
                    )}
                  </div>
                )
              })
              .sort()}
          </div>
        </div>
        <div className={styles.robbot}>
          <img src={Robbot} alt={Robbot} />
        </div>
      </div>
    </PageComponent>
  )
}
export default Profile

// {formsData?.map((careRecipient, index) => {
//   return (
//       <div className={styles.forms}>
//                 <span className={styles.formWrap}>
//                   <p>{careRecipient.careRecipientName}</p>
//                   <img
//                       src={Arrow}
//                       alt={Arrow}
//                       onClick={handleRotateCare}
//                       className={cx({
//                         [styles.rotate]: rotate,
//                       })}
//                   />
//                 </span>
//         {rotate && (
//             <div className={styles.formWrapper}>
//               <ul>
//                 {careRecipient.forms?.map((form) => {
//                   return (
//                       <>
//                         <p>{form.authorizedPersonName}</p>
//                         {form.authorizedPersonItems.map((item) => {
//                           console.log(item)
//                           return (
//                               <li>
//                                 <p>
//                                   {item.periodOfAbsenceFrom} -{' '}
//                                   {item.periodOfAbsenceTo}
//                                 </p>
//                                 <p>
//                                   <button
//                                       onClick={() =>
//                                           handleViewForm(form.reimbursementRef)
//                                       }
//                                   >
//                                     Formular anzeigen
//                                   </button>
//                                   <button
//                                       onClick={() =>
//                                           handleGetPdf(form.reimbursementRef)
//                                       }
//                                       disabled={
//                                           getPdfDisabled === form.reimbursementRef
//                                       }
//                                       className={cx({
//                                         [styles.disabled]:
//                                             getPdfDisabled === form.reimbursementRef,
//                                       })}
//                                   >
//                                     PDF herunterladen
//                                   </button>
//                                 </p>
//                               </li>
//                           )
//                         })}
//                       </>
//                   )
//                 })}{' '}
//               </ul>
//             </div>
//         )}
//       </div>
//   )
// })}
